import { IconCheck } from '@tabler/icons-react';
import { apiImageUrl } from '@shared/lib/media/image-url';
import type { CampaignCosmetic } from '../model/campaign-cosmetics';
import classes from './campaign-cosmetics.module.css';

export const CampaignCosmetics = ({ items }: { items: readonly CampaignCosmetic[] }) =>
  items.length ? (
    <span className={classes.root} role="group" aria-label="Оформление за прохождение кампании">
      {items.map((item) => (
        <span
          key={item.id}
          className={classes.item}
          title={item.name}
          aria-label={`${item.name}${item.owned ? ', получено' : ', за прохождение кампании'}`}
        >
          <img src={apiImageUrl(item.imageUrl)} alt="" />
          {item.owned && <IconCheck className={classes.check} size={12} aria-hidden="true" />}
        </span>
      ))}
    </span>
  ) : null;
